package com.flowyride.core.domain.routing

import com.flowyride.core.domain.model.RouteEngineId

/** All engines known to the app, in display order. */
class RouteEngineRegistry(engines: List<RouteEngine>) {

    val engines: List<RouteEngine> = engines.toList()

    init {
        require(engines.isNotEmpty()) { "At least one route engine is required" }
        require(engines.distinctBy { it.id }.size == engines.size) { "Duplicate route engine ids" }
    }

    val default: RouteEngine
        get() = engines.firstOrNull { it.isAvailable } ?: engines.first()

    fun get(id: RouteEngineId): RouteEngine =
        engines.firstOrNull { it.id == id } ?: throw RoutingException.EngineUnavailable("Unknown engine '${id.value}'")
}
